module.exports = __webpack_public_path__ + "media/svg/li-8962ced7.svg";